import { Component, OnInit, EventEmitter, Input } from '@angular/core';
import { DiagnosisItemStatus } from '../../model/diagnosis-item-status';

@Component({
    selector: 'tx-can-diagnosis-item',
    templateUrl: './can-diagnosis-item.component.html',
    styleUrls: ['./can-diagnosis-item.component.css']
  })
export class CanDiagnosisItemComponent implements OnInit {
    
    _attribute: String;
    _status: DiagnosisItemStatus;
    _value: any;

    constructor() {
    }
  
    ngOnInit() {
    }

    get attribute() {
        return this._attribute;
    }
    
    @Input()
    set attribute(attribute) {
        this._attribute = attribute;
    }

    get status() {
        return this._status;
    }

    @Input()
    set status(status) {
        this._status = status;
    }

    get value() {
        return this._value;
    }

    @Input()
    set value(value) {
        this._value = value;
    }

    timeout() {
        return this._status === DiagnosisItemStatus.TIMEOUT;
    }

    success() {
        return this._status === DiagnosisItemStatus.SUCCESS;
    }

    failed() {
        return this._status === DiagnosisItemStatus.FAILED;
    }

    running() {
        return this._status === DiagnosisItemStatus.RUNNING;
    }
}


// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/diagnosis/component/can-diagnosis-item/can-diagnosis-item.component.ts